import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { BulkBanResponse } from 'types/interfaces/admin/bulkBan';
import { bulkBanToastDetails, bulkBanToastHeadline } from './bulkBan';
import './BulkBanResultToast.css';

interface ContentProps {
  headline: string;
  details: Array<{ id: number; text: string }>;
}

const BulkBanResultToastContent: React.FC<ContentProps> = ({ headline, details }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="bulk-ban-toast">
      <div className="bulk-ban-toast-headline">{headline}</div>
      {details.length > 0 ? (
        <>
          <button
            type="button"
            className="bulk-ban-toast-toggle"
            aria-expanded={expanded}
            onClick={(e) => {
              e.stopPropagation();
              setExpanded((value) => !value);
            }}
          >
            {expanded ? 'Hide details' : `Show details (${details.length})`}
          </button>
          {expanded ? (
            <ul className="bulk-ban-toast-list">
              {details.map((detail) => (
                <li key={detail.id}>{detail.text}</li>
              ))}
            </ul>
          ) : null}
        </>
      ) : null}
    </div>
  );
};

/**
 * Results toast for a bulk ban (Decision 9). With nothing skipped or failed it
 * is a normal auto-closing success toast. With anything to read it stays open
 * until dismissed and a click on it does not close it, so the admin can expand
 * the list.
 */
export const showBulkBanResultToast = (response: BulkBanResponse): void => {
  const headline = bulkBanToastHeadline(response.summary);
  const details = bulkBanToastDetails(response.results);
  const content = <BulkBanResultToastContent headline={headline} details={details} />;

  if (details.length === 0) {
    toast.success(content);
    return;
  }

  const show = response.summary.failed > 0 ? toast.warn : toast.info;
  show(content, { autoClose: false, closeOnClick: false, closeButton: true });
};
